import React from 'react'
import { Col, Row } from 'reactstrap'
import styled from 'styled-components'
import { RoomNameType } from '../../../../constants/Config'
import { Event as EventModel } from '../../../../model/Event'
import { useConfigContext } from '../../../App/App'
import Room from './Room/Room'

const Wrapper = styled.div`
  h1, h2 {
    font-size: 2.8rem;
    font-weight: bold;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  h2 {
    font-size: 2.5rem;
    -webkit-line-clamp: 2;
    font-weight: normal;
  }

  @media screen and (orientation: landscape) {
    h1 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    h2 {
    -webkit-line-clamp: 2;
  }
  }
`

interface IProps {
  event: EventModel
  isPortraitOriented: boolean
}

const Content = ({ event, isPortraitOriented }: IProps) => {
  const { eventTitle, showDescription, showRoomNameType } = useConfigContext()
  const { description, location, room, summary } = event
  const title = summary && summary !== '' ? summary : (eventTitle ? eventTitle : '------')
  const hasDescription = showDescription && description

  const getRoomName = (): string|null => {
    switch (showRoomNameType) {
      case RoomNameType.Ics:
        return location
      case RoomNameType.Json:
        return room ? room.name : null
      default:
        return null
    }
  }

  return (
    <Wrapper>
      <Row className="h-100">
        <Col xs="12" sm={isPortraitOriented ? '12' : '8'}>
          <h1>
            {title}
          </h1>
          {hasDescription && <h2 dangerouslySetInnerHTML={{ __html: description }}/>}
        </Col>
        <Col className="align-self-end" xs="12" sm={isPortraitOriented ? '12' : '4'}>
          {room && <Room room={room} roomName={getRoomName()}/>}
        </Col>
      </Row>
    </Wrapper>
  )
}

export default Content
